import uamClientService from '../uam/uamClientService';

const getClientService = () => uamClientService;

const postUserSubscriptionInfo = (subscription, languageCode, notificationTypes) =>
    getClientService().postUserSubscriptionInfo(subscription, languageCode, notificationTypes);

const putUserSubscriptionInfo = (endpoint, languageCode, notificationTypes) =>
    getClientService().putUserSubscriptionInfo(endpoint, languageCode, notificationTypes);

const delUserSubscriptionInfo = (endpoint) => getClientService().delUserSubscriptionInfo(endpoint);

export default {
    postUserSubscriptionInfo,
    putUserSubscriptionInfo,
    delUserSubscriptionInfo,
};
